<template>
  <div class="form-group">
    <div class="input">
      <input type="text" :class="{'-filled': value}" maxlength="200"
             :id="identifier" :name="identifier" class="form-control"
             :value="value" @input="$emit('update', $event.target.value)">
      <div class="input-background">
        <label :for="identifier" class="control-label">{{ placeholder }}</label>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'TextInput',
  props: {
    identifier: String,
    placeholder: String,
    value: String,
  },
};
</script>
